import { topliApi } from '@/shared/api/topli/TopliApi'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { buildingsByPageQueryKey } from '@/entities/Building'
import { currentResidentialByIdQueryKey } from '@/entities/Residential'
import { PhotoOwner } from '@/entities/Photos'

export const deleteBuilding = async (buidlingId: number) => {
  const response = await topliApi.building.delete(buidlingId)
  return response
}

export const useDeleteBuildingApi = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => deleteBuilding(id),
    onSuccess: (_res, id) => {
      topliApi.photo.deleteAllPhotos({ id, owner_id: PhotoOwner.Building })

      Promise.all([
        queryClient.invalidateQueries({
          queryKey: [buildingsByPageQueryKey],
          refetchType: 'active',
        }),
        queryClient.invalidateQueries({
          queryKey: [currentResidentialByIdQueryKey],
          refetchType: 'active',
        }),
      ])
    },
  })
}
